import $ from 'jquery';

$(() => {
    const $chatMessages = $('.direct-chat-messages');
    $chatMessages.scrollTop($chatMessages.prop('scrollHeight'));
});
